/** WebKit / Safari-specific browser signals. */
export function collectWebkitSpecific() {
  if (typeof window.safari === 'undefined') {
    return {};
  }
  return {
    safari: {
      pushNotification: typeof window.safari.pushNotification !== 'undefined',
    },
  };
}
